import "remixicon/fonts/remixicon.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import PrivacyPolicy from './components/PrivacyPolicy.js';
import TermsAndConditions from './components/TermsAndConditions.js';
import AboutUs from "./components/AboutUs.js";

import Home from "./components/Home.js";
import Blog from "./components/Blog.js";
import Navbar from "./components/Navbar.js";
import Footer from "./components/Footer.js";
import Courses from "./components/Courses.js";
import BlogDeatils from "./components/BlogDeatils.js";
import Signup from "./components/Signup.js";
import Login from "./components/Login.js";
import Logout from "./components/Logout.js";

import Layout from "./Dashboard/Layout.js";
import Dashboard from "./Dashboard/Dashboard.js";
import QuizForm from "./Dashboard/QuizForm.js";

import MyMaterials from "./Dashboard/Material.js";
import ExamList from "./Dashboard/ExamList.js";
import MaterialDetail from "./Dashboard/MaterialDetail.js";
import ProfileUpdate from "./Dashboard/ProfileUpdate.js";
import Counselling from "./Dashboard/Counselling.js";
import CounsellingDeatil from "./Dashboard/CounsellingDeatil.js";
import AgoraCallPage from "./Dashboard/AgoraCallPage.js";

import Resume from "./Dashboard/Resume.js";
import Subscription from "./Dashboard/Subscription.js";
import ExamAlertPage from "./Dashboard/ExamAlertPage.js";

import PrivateRoute from "./components/PrivateRoute";
import ResumeCreate from "./Dashboard/ResumeCreate.js";
import AgoraAudioCallPage from "./Dashboard/AgoraAudioCallPage.js";
import AgoraChat from "./Dashboard/AgoraChat.js";
import NotificationPage from "./Dashboard/NotificationPage.js";

function App() {
  return (
    <div>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="Navbar" element={<Navbar />} />
          <Route path="PrivacyPolicy" element={<PrivacyPolicy />} />
          <Route path="TermsAndConditions" element={<TermsAndConditions />} />
          <Route path="AboutUs" element={<AboutUs />} />
          <Route path="Navbar" element={<Navbar />} />
          <Route path="Signup" element={<Signup />}></Route>
          <Route path="Login" element={<Login />}></Route>
          <Route path="Footer" element={<Footer />} />
          <Route path="/Courses" element={<Courses />} />
          <Route path="/Blog" element={<Blog />} />
          <Route path="/BlogDeatils" element={<BlogDeatils />} />
          <Route path="/Logout" element={<Logout />} />

          {/* Protected routes */}
          <Route element={<PrivateRoute />}>
            <Route element={<Layout />}>
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="/dashboard/notification" element={<NotificationPage />} />
              <Route path="/dashboard/examList" element={<ExamList />} />
              <Route path="quizForm" element={<QuizForm />} />
              <Route path="/dashboard/myMaterials" element={<MyMaterials />} />
              <Route path="material-detail" element={<MaterialDetail />} />
              <Route path="profileUpdate" element={<ProfileUpdate />} />
              <Route path="/dashboard/counselling" element={<Counselling />} />
              <Route path="/dashboard/resume" element={<Resume />} />
              <Route path="/dashboard/subscription" element={<Subscription />} />
              <Route path="/dashboard/exam-alerts" element={<ExamAlertPage />} />
              <Route path="resume/resume-create" element={< ResumeCreate />} />
              <Route path="counselling/counsellingDeatil" element={<CounsellingDeatil />} />
              <Route path="/call/:channelName" element={<AgoraCallPage />} />
              <Route path="/audio_call/:channelName" element={<AgoraAudioCallPage />} />
              <Route path="/chat/:userId/:adminId" element={<AgoraChat />} />
            </Route>
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
